export default [
  {
    path: '/operation/commerce_custom',
    name: 'commerce_custom',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/menus/commerceCustom/commerce_custom_info')
  }
]



// WEBPACK FOOTER //
// ./src/router/subRoutes/commerceCustomRouter.js